'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePage = exports.createPage = exports.fetchPageDonationCount = exports.fetchPage = exports.fetchPages = exports.deserializePage = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var deserializePage = exports.deserializePage = function deserializePage(page) {
  var amountInCents = page.metrics ? page.metrics.fundraising.total_in_cents : page.amount ? page.amount.cents : 0;

  return {
    active: page.active || page.state === 'active',
    campaign: (0, _get2.default)(page, 'campaign.name') || page.campaign || page.campaign_name,
    campaignDate: page.campaign_date || page.event_date,
    charity: (0, _get2.default)(page, 'charity.name') || page.charity || page.beneficiary || page.charity_name,
    coordinates: page.coordinate,
    donationUrl: page.donation_url,
    expired: page.expired,
    fitness: page.metrics ? page.metrics.fitness : page.fitness_activity_overview,
    fitnessGoal: page.fitness_goal,
    groups: page.page_groups,
    hasUpdatedImage: page.meta && page.meta.has_set_image,
    id: page.id,
    image: page.image && page.image.large_image_url,
    name: page.name,
    owner: (0, _get2.default)(page, 'supporter.name') || page.owner_uid || page.user_id,
    raised: amountInCents / 100,
    slug: page.slug,
    story: page.story,
    target: (page.metrics ? page.metrics.fundraising.goal : page.target_cents) / 100,
    teamPageId: page.team_page_id,
    teamRole: page.team_role,
    url: page.url,
    uuid: page.uuid
  };
};

var fetchPages = function fetchPages() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var allPages = params.allPages,
      finalParams = _objectWithoutProperties(params, ['allPages']);

  var mappings = { type: 'type' };
  var transforms = allPages ? {} : {
    type: function type(v) {
      return v === 'individual' ? 'user' : v;
    }
  };

  var promise = allPages ? (0, _client.get)('api/v2/pages', finalParams, { mappings: mappings, transforms: transforms }) : (0, _client.get)('api/v2/search/pages', finalParams, { mappings: mappings, transforms: transforms });

  return promise.then(function (response) {
    return response.pages;
  });
};

exports.fetchPages = fetchPages;
var fetchPage = exports.fetchPage = function fetchPage() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if ((typeof id === 'undefined' ? 'undefined' : _typeof(id)) === 'object') {
    var _id$campaignSlug = id.campaignSlug,
        campaignSlug = _id$campaignSlug === undefined ? (0, _params.required)() : _id$campaignSlug,
        _id$countryCode = id.countryCode,
        countryCode = _id$countryCode === undefined ? (0, _params.required)() : _id$countryCode,
        _id$slug = id.slug,
        slug = _id$slug === undefined ? (0, _params.required)() : _id$slug;


    return (0, _client.get)('api/v3/prerelease/pages/' + countryCode + '/' + campaignSlug + '/' + slug).then(function (response) {
      return response.page;
    });
  }

  return (0, _client.get)('api/v2/pages/' + id).then(function (response) {
    return response.page;
  });
};

var fetchPageDonationCount = exports.fetchPageDonationCount = function fetchPageDonationCount() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.get)('/api/v2/pages/' + id).then(function (data) {
    return data.total_donations;
  });
};

var createPage = exports.createPage = function createPage(_ref) {
  var _ref$birthday = _ref.birthday,
      birthday = _ref$birthday === undefined ? (0, _params.required)() : _ref$birthday,
      campaignDate = _ref.campaignDate,
      _ref$campaignId = _ref.campaignId,
      campaignId = _ref$campaignId === undefined ? (0, _params.required)() : _ref$campaignId,
      charityId = _ref.charityId,
      directMarketingConsent = _ref.directMarketingConsent,
      expiresAt = _ref.expiresAt,
      fitnessGoal = _ref.fitnessGoal,
      giftAid = _ref.giftAid,
      groupValues = _ref.groupValues,
      image = _ref.image,
      inviteToken = _ref.inviteToken,
      name = _ref.name,
      nickname = _ref.nickname,
      redirectTo = _ref.redirectTo,
      skipNotification = _ref.skipNotification,
      slug = _ref.slug,
      story = _ref.story,
      target = _ref.target,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      user = _ref.user;

  return (0, _client.post)('/api/v2/pages?access_token=' + token, {
    birthday: birthday,
    campaign_date: campaignDate,
    campaign_id: campaignId,
    charity_id: charityId,
    direct_marketing_consent: directMarketingConsent,
    expires_at: expiresAt,
    fitness_goal: fitnessGoal,
    gift_aid_eligible: giftAid,
    group_values: groupValues,
    image: image,
    name: name,
    nickname: nickname,
    redirect_to: redirectTo,
    skip_notification: skipNotification,
    slug: slug,
    story: story,
    target: target,
    token: inviteToken,
    uid: user
  }).then(function (response) {
    return response.page;
  });
};

var updatePage = exports.updatePage = function updatePage(pageId, _ref2) {
  var campaignDate = _ref2.campaignDate,
      expiresAt = _ref2.expiresAt,
      fitnessGoal = _ref2.fitnessGoal,
      groupValues = _ref2.groupValues,
      image = _ref2.image,
      name = _ref2.name,
      redirectTo = _ref2.redirectTo,
      slug = _ref2.slug,
      story = _ref2.story,
      target = _ref2.target,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  return (0, _client.put)('/api/v2/pages/' + pageId + '?access_token=' + token, {
    campaign_date: campaignDate,
    expires_at: expiresAt,
    fitness_goal: fitnessGoal,
    group_values: groupValues,
    image: image,
    name: name,
    redirect_to: redirectTo,
    slug: slug,
    story: story,
    target: target
  }).then(function (response) {
    return response.page;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages/everydayhero/index.js
// module id = 1422
// module chunks = 0